import clsx from 'clsx';
import logoUrl from '~assets/logos/logo.svg?url';

interface WordmarkProps {
  /** `nav` = sticky top-left (default). `hero` = large in-section variant for hero block. */
  variant?: 'nav' | 'hero';
  className?: string;
}

/**
 * RAFL/digital wordmark. Single identity marker across every screen.
 *
 * - `nav` variant pins to top-left, respects `--safe-top`, never animates.
 * - `hero` variant is used inside 01-hero block when the design wants the wordmark
 *   doubled in-section (README.md §4 "Wordmark в hero может быть продублирован крупно").
 *
 * Source: README.md §4 "Логотипы" + DESIGN.md §9.1 / §10.
 */
export function Wordmark({ variant = 'nav', className }: WordmarkProps) {
  const isNav = variant === 'nav';
  return (
    <div
      className={clsx(
        isNav &&
          'pointer-events-none absolute left-sp-5 z-20 top-[max(var(--safe-top,0px),0.75rem)]',
        className,
      )}
      aria-label="RAFL/digital"
    >
      <img
        src={logoUrl}
        alt={isNav ? 'RAFL / digital' : ''}
        loading="eager"
        decoding="async"
        draggable={false}
        className={clsx('block h-auto select-none', isNav ? 'w-[88px]' : 'w-[200px]')}
        style={{ filter: 'none' }}
      />
    </div>
  );
}
